import { render, staticRenderFns } from "./tabMenuVisibility.vue?vue&type=template&id=6058ed71&"
import script from "./tabMenuVisibility.vue?vue&type=script&lang=js&"
export * from "./tabMenuVisibility.vue?vue&type=script&lang=js&"
import style0 from "./tabMenuVisibility.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports